import { Flex } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

type Props = {
  title: string;
  content: string;
};

const ListingStat = ({ title, content }: Props) => (
  <Flex flex="1" display="flex" flexDirection="column" alignItems="center">
    <Text textStyle="body-sm" data-testid="ListingStat-Title" asChild>
      <p>{title}</p>
    </Text>

    <Text textStyle="body-bold" data-testid="ListingStat-Content" asChild>
      <p>{content}</p>
    </Text>
  </Flex>
);

export default ListingStat;
